import { Button, StatusIcon } from '@assist/ui';
import { useSession } from '../state/session.js';

/**
 * Layar yang diterima seorang Operator di konsol web — UAT D-14.
 *
 * Peta §5.1 mengarahkan OPR ke aplikasi lapangan. Aplikasi itu belum dibangun, dan
 * itu di luar lingkup. Yang ADA di dalam lingkup adalah bahwa konsol tidak boleh merender
 * Dasbor Manajer sebagai gantinya: Yanto menerima "Antrean keputusan" dan "Susun laporan
 * bulanan" dengan bilah sisi kosong, dan satu-satunya kendali yang berfungsi adalah "Keluar".
 *
 * Tidak ada kebocoran data di sana — RLS tetap membatasi barisnya ke areanya — tapi
 * maksud layarnya bocor, dan seorang operator yang melihat layar manajer belajar
 * bahwa sistem ini tidak tahu siapa dirinya.
 *
 * APA YANG BERUBAH PADA GELOMBANG LAYAR KONSOL
 * -------------------------------------------
 * Layar ini bukan lagi JALAN BUNTU. Sebelumnya ia satu paragraf dan tidak ada apa pun yang
 * dapat dilakukan operator sesudah membacanya — yang secara praktis sama buruknya dengan
 * bilah sisi kosong, hanya lebih sopan.
 *
 * Sekarang dua layar konsol memang miliknya, dan keduanya ada di navigasinya
 * (`modules/M02/module.manifest.json`, butir nav berizin `OPR`):
 *
 *   · **Lapor Temuan** (`/findings/new`) — alur 1 §6, yang sebelumnya tidak dapat dijalani
 *     manusia sama sekali karena aplikasi lapangan belum ada dan konsol tidak punya
 *     pemanggil `POST /v1/findings`;
 *   · **Temuan saya** (`/findings`) — RLS membatasinya ke temuan yang ia laporkan atau
 *     miliki, jadi daftar yang sama melayani operator dan manajer tanpa layar kedua.
 *
 * Kalimatnya tetap jujur: pekerjaan lapangan yang sungguhan — pindai QR, kamera, luring —
 * ada di ponsel, dan itu dikatakan alih-alih disembunyikan di balik dua tombol.
 */
export function FieldAppOnly({ onNavigate }: { onNavigate: (route: string) => void }) {
  const { t, me } = useSession();

  return (
    <section className="page">
      <div className="assist-state">
        <div className="assist-state__icon">
          <StatusIcon kind="information" size={32} />
        </div>
        <h2 className="assist-state__title">{t('state.fieldApp.title')}</h2>
        <p className="assist-state__body">{t('state.fieldApp.body')}</p>
        <p className="assist-state__help">{t('state.fieldApp.meanwhile')}</p>
        <p className="page__actions">
          <Button variant="primary" onClick={() => onNavigate('/findings/new')}>
            {t('report.title')}
          </Button>
          <Button variant="secondary" onClick={() => onNavigate('/findings')}>
            {t('state.fieldApp.myFindings')}
          </Button>
        </p>
        <p className="assist-state__help">{t('state.fieldApp.whoCanHelp')}</p>
        {me?.full_name ? <p className="assist-state__help">{me.full_name}</p> : null}
      </div>
    </section>
  );
}
